import React from 'react';
import {has as _has} from 'lodash';
import PropTypes from 'prop-types';
/* eslint import/no-unresolved: 0 */
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {Segment} from 'semantic-ui-react';

import {gql, graphql, withApollo} from 'react-apollo';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {routes} from '@constants/routes';
import {PULL} from '@constants/variables';
import {sortByTextValue} from '@utils/sorters';
import {handleEditStreamNameModal} from '@modules/client/utils/clientTabsLayoutHelper';

import {exportExcel} from '../utils/export/productThirdPartyStreamNamesIndexExcel';
import ProductThirdPartyStreamNamesPullForm from '../forms/ProductThirdPartyStreamNamesPullForm';
import ProductThirdPartyStreamNamesPullTable from '../components/ProductThirdPartyStreamNamesPullTable';
import ProductThirdPartyStreamNamesIndexButtons from '../components/ProductThirdPartyStreamNamesIndexButtons';
import * as thirdPartyStreamNamesPullGraphQl from '../../../graphql/clients/thirdPartyStreamNamesPull';

export class ProductThirdPartyStreamNamesPullIndex extends React.Component {
    static propTypes = {
        client: PropTypes.object,
        DataProductThirdPartyStreamNamesPull: PropTypes.object,
        loading: PropTypes.bool,
        match: PropTypes.object.isRequired,
        Modal: PropTypes.shape({
            setModal: PropTypes.func,
        }),
        pullOrigins: PropTypes.array.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }),
    };

    constructor(props) {
        super(props);

        this.state = {
            loadingModal: false,
            modalOpenedOnPageLoad: false,
            productThirdPartyStreamNamesPull: [],
        };
    }

    componentDidUpdate(prevProps) {
        const {
            DataProductThirdPartyStreamNamesPull: { thirdPartyClientStreamNamesPull, loading },
            match,
        } = this.props;
        const streamNamesPullRoutes = routes.clients.products.thirdParty.streamNamesPull;

        if (
            thirdPartyClientStreamNamesPull &&
            thirdPartyClientStreamNamesPull !== prevProps.DataProductThirdPartyStreamNamesPull.thirdPartyClientStreamNamesPull
        ) {
            this.setState({
                productThirdPartyStreamNamesPull: sortByTextValue(thirdPartyClientStreamNamesPull, 'stream_name'),
            });
        }

        if (this.state.modalOpenedOnPageLoad) {
            return false;
        }

        const prevLoading = prevProps.DataProductThirdPartyStreamNamesPull.loading;

        if (prevLoading && !loading) {

            if (match.path === streamNamesPullRoutes.add.path) {
                this.openModal({});
            }

            else if (match.path === streamNamesPullRoutes.edit.path) {
                const streamNames = thirdPartyClientStreamNamesPull.filter(
                    item => convertToInt(item.id) === convertToInt(match.params.thirdPartyClientPullStreamNameId)
                ).pop();

                handleEditStreamNameModal(
                    streamNames || {},
                    'clients.products.thirdParty.streamNamesPull.index',
                    convertToInt(match.params.id),
                    'pull',
                    this.openModal
                );
            }
        }
    }

    resetIndexUrl = () => {
        this.props.history.push(getLink('clients.products.thirdParty.streamNamesPull.index', {
            id: this.props.match.params.id,
        }));
    };

    queryDataForModal = (id) => {
        let modalLink = getLink('clients.products.thirdParty.streamNamesPull.edit', {
            id: this.props.match.params.id,
            thirdPartyClientPullStreamNameId: id,
        });

        this.setState(() => ({
            loadingModal: true,
        }));

        this.props.client.query({
            query: ProductThirdPartyStreamNamePullQuery,
            variables: {
                id: id,
            },
        }).then((result) => {
            this.setState(() => ({
                loadingModal: false,
            }));

            this.openModal(result.data.thirdPartyClientStreamNamePull, modalLink);
        });
    };

    prepareDataForModal = (id) => {
        this.setState(() => ({
            modalOpenedOnPageLoad: true,
        }));

        let modalLink = getLink('clients.products.thirdParty.streamNamesPull.add', {
            id: this.props.match.params.id,
        });

        if (!isNaN(id)) {
            this.queryDataForModal(id);
        } else if (_has(id, 'id')) {
            this.queryDataForModal(id.id);
        } else {
            this.openModal({}, modalLink);
        }
    };

    openModal = (data, modalLink) => {
        const {
            Modal: {setModal},
        } = this.props;

        this.props.history.push(modalLink);

        setModal({
            content: <ProductThirdPartyStreamNamesPullForm
                formData={{
                    pullOrigins: this.props.pullOrigins.map((pullOrigin) => ({
                        key: pullOrigin.id,
                        text: pullOrigin.name,
                        value: pullOrigin.id,
                    })),
                    thirdPartyStreamName: data,
                }}
                resetIndexUrl={this.resetIndexUrl}
            />,
            isVisible: true,
            size: 'small',
            onClose: this.resetIndexUrl,
        });
    };

    render() {
        return (
            <Segment basic loading={this.state.loadingModal} className='--marginTopNegative-15 --paddingTop-0'>
                <HeaderRenderer
                    buttons={ProductThirdPartyStreamNamesIndexButtons}
                    buttonsProps={{
                        prepareDataForModal: this.prepareDataForModal,
                        type: PULL,
                    }}
                    exportExcelParams={exportExcel(
                        this.state.productThirdPartyStreamNamesPull,
                        this.props.match.params.id,
                        PULL
                    )}
                    loading={this.props.DataProductThirdPartyStreamNamesPull.loading}
                />
                <ProductThirdPartyStreamNamesPullTable
                    editClick={this.prepareDataForModal}
                    loading={this.props.DataProductThirdPartyStreamNamesPull.loading}
                    productThirdPartyStreamNamesPull={this.state.productThirdPartyStreamNamesPull}
                />
            </Segment>
        );
    }
}

const ProductThirdPartyStreamNamesPullQuery = gql(thirdPartyStreamNamesPullGraphQl.thirdPartyStreamNamesPullIndex);
const ProductThirdPartyStreamNamePullQuery = gql(thirdPartyStreamNamesPullGraphQl.thirdPartyStreamNamePull);

const ProductThirdPartyStreamNamesPullWithGraphQL = compose(
    graphql(ProductThirdPartyStreamNamesPullQuery, {
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    thirdPartyClientPullOrigin: props.pullOrigins.map((pullOrigin) => convertToInt(pullOrigin.id)),
                },
            };
        },
        name: 'DataProductThirdPartyStreamNamesPull',
    })
)(ProductThirdPartyStreamNamesPullIndex);

const mapDispatchToProps = mapModulesToProps(['Modal']),
    mapStateToProps = (state) => {
        return {
            pullOrigins: state.app.entities.thirdPartyClientPullOrigins.pullOrigins,
        };
    };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withApollo(ProductThirdPartyStreamNamesPullWithGraphQL))
);
